import { OrderStatus, WarehouseStaggingStatus } from "@/enums";
import moment from "moment";
import { isProxy, toRaw } from 'vue';
import { notify } from "@kyvg/vue3-notification";
import { Notify } from "@/models";
import store from '@/store';
export default class UtilService {
    private defaultFormat: string = "MM/DD/YYYY";

    getStandardDate(dateStr: string, dateFormat: string = this.defaultFormat): any {
        let timezoneOffesetInMinutes: number = new Date().getTimezoneOffset();
        let date;
        // if (timezoneOffesetInMinutes > 0) {
        //     date = moment(dateStr).subtract(timezoneOffesetInMinutes, "minutes").format(dateFormat);
        // } else {
        //     date = moment(dateStr).add(Math.abs(timezoneOffesetInMinutes), "minutes").format(dateFormat);
        // }
        if (timezoneOffesetInMinutes > 0) {
            date = moment(dateStr).subtract(timezoneOffesetInMinutes, "minutes");
        }
        else {
            date = moment(dateStr).add(Math.abs(timezoneOffesetInMinutes), "minutes");
        }

        return date.toDate();
    }

    getStandardDateStr(dateStr: string, dateFormat: string = this.defaultFormat) {
        return moment(dateStr).format(dateFormat).toString();
    }

    log(key: string, value: any) {
        console.log(key, value);
    }

    error(str: any) {
        console.error(str);
    }

    getOrderStatusStr(id: WarehouseStaggingStatus) {
        if (id == WarehouseStaggingStatus.ReadyToStage) {
            return "Ready To Stage";
        } else if (id == WarehouseStaggingStatus.Staged) {
            return "Stagged";
        } else if (id == WarehouseStaggingStatus.Loaded) {
            return "Loaded";
        } else if (id == WarehouseStaggingStatus.Shipped) {
            return "Shipped";
        } else if (id == WarehouseStaggingStatus.Delivered) {
            return "Delivered";
        }
        return "";
    }

    customJsonStringify(json: any) {
        if (!this.checkJsonObject(json))
            return JSON.stringify(json);
        return json;
    }

    checkJsonObject(json: any) {
        try {
            JSON.parse(json);
        } catch (ex) {
            return false;
        }

        return true;
    }

    parseProxyObject(someData: any) {
        let rawData = someData;

        if (isProxy(someData)) {
            rawData = toRaw(someData)
        }
        return rawData;
    }
    sortArrayOfObjectbyKey(arr: any, key: any) {
        return arr.sort((a: any, b: any) => {
            var keyA = new Date(a[key]),
                keyB = new Date(b[key]);
            // Compare the 2 dates
            if (keyA < keyB) return -1;
            if (keyA > keyB) return 1;
            return 0;
        });
    }

    notify(notification: Notify): void {
        notify(notification);
        return;
    }

    getFormatedDate(date: any, dateFormat: string = this.defaultFormat): any {
        if (!date) return '';
        return moment(date).format(dateFormat);
    }
    geteSignPermission(): boolean {
        const userDataString = localStorage.getItem('userData');
        if (!userDataString) return false;
    
        const userData = JSON.parse(userDataString);
        const permissions = userData?.UserPermission?.filter((x: any) => 
            x.Package === "GRN" && x.SecurityOption === "COMNU"
        ) || [];
    
        return permissions.length > 0 && parseInt(permissions[0].SecurityLevel) > 4;
    }
    getCongigurationPermission(): boolean {
        const userDataString = localStorage.getItem('userData');
        if (!userDataString) return false;
    
        const userData = JSON.parse(userDataString);
        const permissions = userData?.UserPermission?.filter((x: any) => 
            x.Package === "INV" && x.SecurityOption === "IVOPT"
        ) || [];
    
        return permissions.length > 0 && parseInt(permissions[0].SecurityLevel) > 1;
    }
    getPhysicalCountPermission(): boolean {
        const userDataString = localStorage.getItem('userData');
        if (!userDataString) return false;
    
        const userData = JSON.parse(userDataString);
        const permissions = userData?.UserPermission?.filter((x: any) => 
            x.Package === "INV" && x.SecurityOption === "IVCNT"
        ) || [];
    
        return permissions.length > 0 && parseInt(permissions[0].SecurityLevel) > 1;
    }

    stringIsNullOrEmpty(str:string){
        return !str || str.trim() === "";
    }

    isDateValid(dateStr:string){
        let str = this.stringIsNullOrEmpty(dateStr);
        if(str == true) return true;
        else 
            return !isNaN(new Date(dateStr).getTime())
    }

    get ActiveAgents(){
        var activeAgents = store.getters.getAgentNames || [];
        return activeAgents;
    }
}